import { Box } from "@mui/material";
import { winnersAssets } from "assets/cdn";
import { FeaturesFlags } from "helpers";
import Search from "./components/Search";
import { Fragment, useEffect } from "react";
import { WinnersIcon } from "utils/svgIcons";
import PostList from "./components/PostList";
import { NewsPageContentSkeleton } from "./skeleton";
import PageTopNav from "../../components/PageTopNav";
import { useEnvContext } from "../../contexts/EnvProvider";
import { PageContent } from "../../components/PageContent";
import SectionHeader from "components/Section/SectionHeader";
import { useWebWinners } from "./hooks/useWebWinners";
import { Background, Container, Characters } from "./styles";
import { useImagePath } from "hooks";
import { PrivateRoute } from "routes/PrivateRoute";

const Winners = () => {
	const { isFeatureFlagEnabled } = useEnvContext();
	const { getImage } = useImagePath("cdn");
	const {
		posts,
		currentPageNum,
		setCurrentPageNum,
		totalPages,
		searchTerm,
		setSearchTerm,
		isLoading
	} = useWebWinners();

	const getHeaderText = () => {
		let text = "LATEST WINNERS";
		if (searchTerm || currentPageNum || totalPages) {
			if (searchTerm || currentPageNum > 1) {
				text = "WINNERS";
			}
		}
		return text;
	};

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<PrivateRoute isEnabled={isFeatureFlagEnabled(FeaturesFlags.WINNERS)}>
			<Fragment>
				<Container>
					<Background src={getImage(winnersAssets.header.background)} />
					<Characters src={getImage(winnersAssets.header.characters)} />
					<PageTopNav
						navItemColor="#FFE37E"
						sectionMenuData={[]}
						isLandingPage
					/>
					<Search
						searchTerm={searchTerm}
						setSearchTerm={setSearchTerm}
						setCurrentPageNum={setCurrentPageNum}
					/>
				</Container>

				<PageContent source={"winners_list_page"} enableBackToTop>
					<Box>
						<SectionHeader text={getHeaderText()} icon={<WinnersIcon />} />
					</Box>
					{isLoading ? <NewsPageContentSkeleton /> : <PostList posts={posts} />}
				</PageContent>
			</Fragment>
		</PrivateRoute>
	);
};

export default Winners;
